import { ImageIcon } from "lucide-react";
import { ProductQualityMetric } from "../../types/api";
import React from "react";

interface ProductImageProps {
    product: ProductQualityMetric;
}

const ProductImage = ({ product }: ProductImageProps): React.JSX.Element => {
    const hasImage = product.images_objects.length > 0 || !!product?.featured_image;
    return (
        <div className="w-12 h-12 relative flex-shrink-0">
            {hasImage ? (
                <img
                    src={product?.featured_image || product.images_objects[0].image_url}
                    alt={product.title}
                    className="w-12 h-12 object-cover rounded-sm"
                    onError={(e): void => {
                        e.currentTarget.style.display = "none";
                        e.currentTarget.parentElement
                            ?.querySelector(".fallback-icon")
                            ?.classList.remove("hidden");
                    }}
                />
            ) : (
                <ImageIcon className="w-6 h-6 text-gray-400" />
            )}
            <ImageIcon className="w-12 h-12 text-gray-400 fallback-icon hidden absolute top-0 left-0" />
        </div>
    );
};

export default ProductImage;